import React from 'react'
import { BettingOddsPartner } from './type'

export interface IBettingOddsContext {
  isAdult: boolean
  partner?: BettingOddsPartner
}

export const BettingOddsContext = React.createContext<IBettingOddsContext>({ isAdult: false })
